import { PrebidModuleParameter } from 'features/globalSetup/types/prebidModule'
import { WorkspacePrebidModuleParameter } from 'features/globalSetup/types/workspacePrebidModule'

export const prepareValue = (
  name: PrebidModuleParameter['name'],
  parameters: WorkspacePrebidModuleParameter[],
): WorkspacePrebidModuleParameter['value'] => {
  const parameter: undefined | WorkspacePrebidModuleParameter = parameters.find(
    (parameter: WorkspacePrebidModuleParameter) => parameter.name === name,
  )

  return parameter?.value ?? ''
}
